import { of, Subject, EMPTY, defer, NEVER } from 'rxjs'
import { catchError, switchMap, map, tap, startWith } from 'rxjs/operators'
import {
  exportKey as cryptoExportKey,
  exportKeys as cryptoExportKeys,
  encrypt as cryptoEncrypt,
  decrypt as cryptoDecrypt,
  listKeys,
  testKey
} from '../helpers/webcrypto'
import debug from '../core/debug'
import { observeRequest } from '../helpers/api'
import dayjs from 'dayjs'
import { isValidResponse } from '../helpers/dataflow'
import { URL_CRYPTO_KEY_ADD } from '../constants/urls'
import { saveAs } from 'file-saver'
import { CRYPTO_DATE_TIME_FORMAT } from '../constants/locale'

const encryptionObserveRequest = observeRequest({ forbiddenAllowed: false })

const Empty = EMPTY

export const EncryptionKeysLoaded = defer(() => listKeys())
  .pipe(map(keys => keys.length > 0))

export const pushEncryptionKeyUrl = (keyUri) => {
  return encryptionObserveRequest({
    url: URL_CRYPTO_KEY_ADD,
    method: 'put',
    body: JSON.stringify({ keyUri }),
    headers: {
      'Content-type': 'application/json'
    }
  }).pipe(
    catchError((e) => of({ success: false, message: e.message })),
    map(r => ({ success: isValidResponse(r) })),
    tap(() => EncryptionKeysSource.next(true))
  )
}

export const loadKey = (url) => encryptionObserveRequest({ url, mode: 'cors' }).pipe(
  switchMap(
    r => isValidResponse(r)
      ? testKey(r)
      : of(false)
  )
)

const downloadFile = (filename, content) => {
  saveAs(new Blob([content]), filename) // eslint-disable-line
}

// EncryptionKeys observable allows to reuse cryptokeys in batch decryption i.e. when you first load existing comments
const EncryptionKeysSource = new Subject()
export const EncryptionKeys = EncryptionKeysSource.pipe(startWith(true),switchMap(listKeys))

// Encrypt with latest encryption key
export const requestEncrypted = function (obj) {
  return cryptoEncrypt(obj)
    .first()
}

// Decrypt using all available encryption keys
export const requestDecrypted = function (encrypted) {
  return cryptoDecrypt(encrypted).pipe(
    catchError(e => debug.warn(e) || Empty)
  )
}

export const exportKey = function () {
  return cryptoExportKey().pipe(
    catchError(e => alert(e) || NEVER)),
    tap(aesKey => downloadFile(
      dayjs().format(CRYPTO_DATE_TIME_FORMAT) + '.fckey',
      aesKey
    )
  )
}

export const exportKeys = function () {
  return cryptoExportKeys().pipe(
    catchError(e => alert(e) || NEVER),
    tap(exportText => downloadFile(
      dayjs().format(CRYPTO_DATE_TIME_FORMAT) + '.fckeylist',
      exportText
    ))
  )
}
